import React from 'react';

export default function PropietarioMantenimiento({
  anioSeleccionadoProp,
  setAnioSeleccionadoProp,
  cuotasPropietarioPorAnio,
  formatearMonto,
  subiendoVoucherPropId,
  subirVoucherPropietario,
  abrirArchivoConLimiteGlobal
}) {

  // 🎨 Función auxiliar para definir el color y texto según el estado del pago
  const obtenerBadgeEstado = (item) => {
    if (!item.voucherUrl) {
      return {
        texto: '⏳ Pendiente de pago',
        bg: '#fef3c7',
        color: '#d97706',
        border: '1px solid #fde68a'
      };
    }

    const estado = (item.estadoPago || '').toLowerCase();

    if (estado.includes('revisado') || estado.includes('validado') || estado.includes('aprobado')) {
      return {
        texto: item.estadoPago || '✅ Pago Revisado',
        bg: '#dcfce7',
        color: '#166534',
        border: '1px solid #bbf7d0'
      };
    } else if (estado.includes('revisión')) {
      return {
        texto: item.estadoPago || '🔍 En revisión',
        bg: '#e0f2fe',
        color: '#0369a1',
        border: '1px solid #bae6fd'
      };
    } else if (estado.includes('rechazado')) {
      return {
        texto: item.estadoPago || '❌ Rechazado',
        bg: '#fee2e2',
        color: '#991b1b',
        border: '1px solid #fecaca'
      };
    }

    return {
      texto: item.estadoPago || 'Voucher enviado',
      bg: '#dcfce7',
      color: '#166534',
      border: '1px solid #bbf7d0'
    };
  };

  return (
    <div style={{ backgroundColor: '#ffffff', border: '1px solid #e2e8f0', borderRadius: '16px', padding: '30px', boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.05)' }}>
      
      {/* Encabezado y Selector de Año */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '25px', flexWrap: 'wrap', gap: '20px' }}>
        <div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '8px' }}>
            <div style={{ backgroundColor: '#e0f2fe', color: '#0284c7', width: '40px', height: '40px', borderRadius: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.2rem', boxShadow: '0 4px 6px -1px rgba(2, 132, 199, 0.2)' }}>
              📄
            </div>
            <h3 style={{ margin: 0, color: '#0f172a', fontSize: '1.35rem', fontWeight: '800' }}>
              Historial de Cuotas por Año
            </h3>
          </div>
          <p style={{ color: '#64748b', fontSize: '0.9rem', margin: 0, lineHeight: '1.5' }}>
            Selecciona el año para consultar tus recibos de mantenimiento y colgar tus comprobantes de pago.
          </p>
        </div>

        {/* Selector de Año Estilizado */}
        <div style={{ backgroundColor: '#f8fafc', border: '1px solid #cbd5e1', borderRadius: '12px', padding: '10px 16px', display: 'flex', alignItems: 'center', gap: '10px', boxShadow: 'inset 0 2px 4px 0 rgba(0, 0, 0, 0.02)' }}>
          <label style={{ fontWeight: '700', fontSize: '0.85rem', color: '#475569', textTransform: 'uppercase', letterSpacing: '0.5px' }}>📅 Año:</label>
          <select 
            value={anioSeleccionadoProp} 
            onChange={e => setAnioSeleccionadoProp(e.target.value)} 
            style={{ padding: '8px 12px', borderRadius: '8px', border: '1px solid #cbd5e1', fontWeight: '700', fontSize: '0.95rem', backgroundColor: 'white', color: '#0f172a', cursor: 'pointer', outline: 'none' }}
          >
            {['2024','2025','2026','2027','2028','2029','2030'].map(a => <option key={a} value={a}>{a}</option>)}
          </select>
        </div>
      </div>

      {/* Tabla Estilizada */}
      <div style={{ overflowX: 'auto', width: '100%', WebkitOverflowScrolling: 'touch', borderRadius: '12px', border: '1px solid #e2e8f0' }}>
        <table className="tabla-propietarios" style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left', fontSize: '0.9rem' }}>
          <thead>
            <tr style={{ backgroundColor: '#f8fafc', borderBottom: '2px solid #e2e8f0', color: '#334155', textTransform: 'uppercase', fontSize: '0.75rem', letterSpacing: '0.5px' }}>
              <th style={{ padding: '14px 16px' }}>Periodo</th>
              <th style={{ padding: '14px 16px' }}>Cuota Asignada</th>
              <th style={{ padding: '14px 16px' }}>F. Emisión</th>
              <th style={{ padding: '14px 16px' }}>F. Vencimiento</th>
              <th style={{ padding: '14px 16px' }}>Recibo Oficial PDF</th>
              <th style={{ padding: '14px 16px' }}>Estado de Pago</th>
              <th style={{ padding: '14px 16px' }}>Acciones Voucher</th>
            </tr>
          </thead>
          <tbody>
            {cuotasPropietarioPorAnio.length === 0 ? (
              <tr>
                <td colSpan="7" style={{ textAlign: 'center', padding: '40px', color: '#64748b', fontStyle: 'italic', backgroundColor: '#ffffff' }}>
                  No hay cuotas archivadas ni registradas para el año {anioSeleccionadoProp}.
                </td>
              </tr>
            ) : (
              cuotasPropietarioPorAnio.map((item, index) => {
                const esReciboMultiple = item.departamento && item.departamento.includes('_');
                const sufijoRecibo = esReciboMultiple ? item.departamento.split('_')[1] : null;
                const badge = obtenerBadgeEstado(item);

                // 🔒 Determinamos si el pago ya fue verificado/aprobado por la administración
                const estadoLower = (item.estadoPago || '').toLowerCase();
                const esVerificado = estadoLower.includes('revisado') || estadoLower.includes('validado') || estadoLower.includes('aprobado');

                return (
                  <tr key={item.id} style={{ borderBottom: '1px solid #f1f5f9', backgroundColor: index % 2 === 0 ? '#ffffff' : '#fafafa', transition: 'background-color 0.15s' }}>
                    <td style={{ padding: '14px 16px' }}>
                      <strong style={{ color: '#0f172a' }}>{item.mes} {item.anio}</strong>
                      {esReciboMultiple && (
                        <div style={{ fontSize: '0.75rem', color: '#0284c7', fontWeight: '700', marginTop: '3px', display: 'inline-block', backgroundColor: '#e0f2fe', padding: '2px 6px', borderRadius: '4px' }}>
                          📄 Recibo N° {sufijoRecibo}
                        </div>
                      )}
                    </td>
                    <td style={{ padding: '14px 16px', fontWeight: '700', color: '#047857' }}>{formatearMonto(item.cuota)}</td>
                    <td style={{ padding: '14px 16px', color: '#64748b' }}>{item.fechaEmision || '-'}</td>    
                    <td style={{ padding: '14px 16px', color: '#64748b' }}>{item.fechaVencimiento || '-'}</td>
                    <td style={{ padding: '14px 16px' }}> 
                      {item.pdfUrls && item.pdfUrls.length > 0 ? (
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                          {item.pdfUrls.map((pdf, idx) => {
                            const urlPdf = pdf.url || pdf;
                            return (
                              <button 
                                key={idx}
                                type="button"
                                onClick={() => abrirArchivoConLimiteGlobal(urlPdf, `${item.id}_pdf_${idx}`)}
                                style={{ background: 'none', border: '1px solid #bae6fd', backgroundColor: '#f0f9ff', color: '#0284c7', fontWeight: '700', cursor: 'pointer', padding: '6px 10px', borderRadius: '6px', textAlign: 'left', fontSize: '0.8rem', display: 'inline-flex', alignItems: 'center', gap: '4px' }}
                              >
                                <span>📄</span> Ver Recibo {idx + 1} <span>↗</span>
                              </button>
                            );
                          })}
                        </div>
                      ) : item.pdfUrl ? (
                        <button 
                          type="button"
                          onClick={() => abrirArchivoConLimiteGlobal(item.pdfUrl, item.id)}
                          style={{ background: 'none', border: '1px solid #bae6fd', backgroundColor: '#f0f9ff', color: '#0284c7', fontWeight: '700', cursor: 'pointer', padding: '6px 10px', borderRadius: '6px', fontSize: '0.8rem', display: 'inline-flex', alignItems: 'center', gap: '4px' }}
                        >
                          <span>📄</span> Descargar Recibo <span>↗</span>
                        </button>
                      ) : (
                        <span style={{ color: '#94a3b8', fontStyle: 'italic', fontSize: '0.85rem' }}>En preparación</span>
                      )}
                    </td>
                    <td style={{ padding: '14px 16px' }}>
                      <span style={{ 
                        backgroundColor: badge.bg, 
                        color: badge.color, 
                        padding: '6px 10px', 
                        borderRadius: '20px', 
                        fontWeight: '700', 
                        fontSize: '0.78rem',
                        display: 'inline-block',
                        border: badge.border
                      }}>
                        {badge.texto}
                      </span>
                    </td>
                    <td style={{ padding: '14px 16px' }}>
                      <div style={{ display: 'flex', gap: '8px', alignItems: 'center', flexWrap: 'wrap' }}>
                        {item.voucherUrl && (
                          <button 
                            type="button"
                            onClick={() => abrirArchivoConLimiteGlobal(item.voucherUrl, `${item.id}_voucher`)}
                            style={{ backgroundColor: '#0284c7', color: 'white', padding: '7px 12px', borderRadius: '8px', fontSize: '0.8rem', fontWeight: '700', border: 'none', cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: '4px', boxShadow: '0 2px 4px rgba(2, 132, 199, 0.2)' }}
                          >
                            <span>👁️</span> Ver
                          </button>
                        )}

                        {/* 🔒 Si ya está verificado, bloqueamos el botón de subida/cambio para evitar sobreescrituras por error */}
                        {!esVerificado ? (
                          <label style={{ backgroundColor: '#10b981', color: 'white', padding: '7px 12px', borderRadius: '8px', cursor: 'pointer', fontSize: '0.8rem', fontWeight: '700', display: 'inline-flex', alignItems: 'center', gap: '4px', boxShadow: '0 2px 4px rgba(16, 185, 129, 0.2)', transition: 'background-color 0.2s' }}>
                            <span>{item.voucherUrl ? '🔄' : '📤'}</span> {subiendoVoucherPropId === item.id ? '⏳ Subiendo...' : (item.voucherUrl ? 'Cambiar' : 'Subir Voucher')}
                            <input type="file" accept=".pdf, .jpg, .jpeg, .png" onChange={(e) => subirVoucherPropietario(e, item.id)} style={{ display: 'none' }} disabled={subiendoVoucherPropId === item.id} />
                          </label>
                        ) : (
                          <span style={{ fontSize: '0.78rem', color: '#166534', fontWeight: '700', backgroundColor: '#dcfce7', padding: '6px 10px', borderRadius: '6px', border: '1px solid #bbf7d0', display: 'inline-flex', alignItems: 'center', gap: '4px' }}>
                            🔒 Bloqueado (Verificado)
                          </span>
                        )}
                      </div>
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}